import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import SideBarBg from './sidebar-bg'
import { renderToStaticMarkup } from 'react-dom/server'

export const useStyles = makeStyles(({ breakpoints, palette, spacing }) => {
  const svgString = encodeURIComponent(
    renderToStaticMarkup(<SideBarBg background={palette.primary.main} />)
  )

  return {
    sideBar: {
      backgroundImage: `url("data:image/svg+xml,${svgString}")`,
      [breakpoints.down('md')]: {
        padding: '21px',
        margin: '12px'
      },
      [breakpoints.up('md')]: {
        padding: '71px'
      },
      color: '#fff',
      height: '100%'
    },
    sideBarContent: {
      textAlign: 'center',
      [breakpoints.up('md')]: {
        position: 'relative',
        top: '15%'
      }
    },
    main: {
      padding: '20px'
    },
    title: {
      marginBottom: '20px',
      [breakpoints.down('md')]: {
        fontSize: '45px'
      },
      [breakpoints.up('md')]: {
        fontSize: '50px'
      },
      textAlign: 'center',
      fontWeight: 600,
      lineHeight: 'normal'
    },
    description: {
      marginBottom: '20px',
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: 'normal'
    },
    registerBtn: {
      display: 'block',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      color: '#fff',
      textAlign: 'center',
      fontSize: '14px',
      width: '100%',
      padding: '15px 26px',
      letterSpacing: '0.28px',
      borderRadius: '4px',
      border: '1px solid #fff',
      transition: 'all 1s',
      '&:hover': {
        background: '#fff',
        color: '#000'
      }
    },
    divider: {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '18px',
      '&::before, &::after': {
        width: '52px',
        borderTop: '1px solid #fff'
      }
    },
    footer: {
      borderTop: '1px solid rgba(185, 183, 189, 1)',
      padding: spacing(3, 0),
      marginTop: spacing(4)
    },

    separator: {
      borderLeft: '1px solid #B9B7BD;',
      width: '1px',
      height: '17px'
    },

    copyrightText: {
      textAlign: 'center',
      marginY: 2,
      fontSize: '13px'
    }
  }
})
